var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcMixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_mixed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,49a2.34,2.34,0,1,1-4.3-1.76c.63-1.55,3.72-2.6,3.61-2.69S46.64,47.42,46,49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.71,51.46c.11.1-3,1.14-3.61,2.69a2.34,2.34,0,1,0,4.3,1.76C34,54.36,32.57,51.45,32.71,51.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.34,34.41a8,8,0,0,0-10.47-7.63,10.23,10.23,0,0,0-20.4,1,11,11,0,0,0,.2,2h-1.9a6.31,6.31,0,0,0,0,12.62H50a6.26,6.26,0,0,0,4.67-2.08A8,8,0,0,0,57.34,34.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.44,48.05H29.37l1.05,1.84-.73.48-1-1.92-1,2L26.94,50l1-1.94-2.09.05v-.93h2.05l-1.12-1.9.73-.51,1.1,2,1.06-2.05.75.46-1.07,2,2.07,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9,48.05H36.83l1.06,1.84-.74.48-1-1.92-1,2L34.41,50l1-1.94-2.09.05v-.93h2.05l-1.12-1.9.74-.51,1.1,2,1-2.05.76.46-1.08,2,2.07,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.65,55.12H39.58L40.64,57l-.74.49-1-1.92-1,2-.73-.45,1-1.94-2.09.05v-.93h2.05L37,52.34l.74-.51,1.09,2,1.06-2.05.75.46-1.07,2,2.07-.05Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcMixed);
export default __webpack_public_path__ + "static/media/dc_mixed.c8370baff1ab7a3108681c7771b4f10d.svg";
export { ForwardRef as ReactComponent };